import { FC } from 'react'

import { GetProps, Typography } from 'antd'

const Title: FC<GetProps<typeof Typography.Title>> = ({ style, ...props }) => {
  return <Typography.Title style={{ fontFamily: 'Russo One', fontWeight: 500,  ...style }} {...props} />
}

export { Title }
